export default {
    floors:         { method: 'get',    url: 'floors' },
    floorsFilter:   { method: 'get',    url: 'floors/filter' },
    createFloor:    { method: 'post',   url: 'floors'},
    updateFloor:    { method: 'put',    url: 'floors/{id}'},
    deleteFloor:    { method: 'delete', url: 'floors/{id}'}
}